var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vc-date-picker',{attrs:{"is-range":""},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var inputValue = ref.inputValue;
var inputEvents = ref.inputEvents;
return [_c('input',_vm._g({staticClass:"date",attrs:{"placeholder":"All"},domProps:{"value":inputValue.start?inputValue.start +' - '+ inputValue.end:''}},inputEvents.start))]}}]),model:{value:(_vm.range),callback:function ($$v) {_vm.range=$$v},expression:"range"}})}
var staticRenderFns = []

export { render, staticRenderFns }